import React from 'react';
import { FormGroup, Label, CustomInput } from 'reactstrap';
import { withTranslation } from 'react-i18next';

const CheckBox = ({ id, label, checked, onChange, t, ...props }) => {
  return (
    <FormGroup disabled={props.disabled}>
      <Label
        for={id}
        className={props.required ? 'required' : ''}
        disabled={props.disabled}
      >
        {t(label)}
      </Label>
      <CustomInput
        type={props.type}
        id={id}
        checked={checked}
        onChange={(e) => {
          if (onChange) {
            onChange(e.target.checked);
          }
        }}
        disabled={props.disabled}
      />
    </FormGroup>
  );
};

CheckBox.defaultProps = {
  type: 'checkbox',
};

export default withTranslation('app')(CheckBox);
